import { render, staticRenderFns } from "./MonthlyClosing.vue?vue&type=template&id=64720a09&"
import script from "./MonthlyClosing.vue?vue&type=script&lang=js&"
export * from "./MonthlyClosing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports